import { ofType } from "redux-observable";
import { EMPTY, from } from "rxjs";
import { retry, switchMap } from "rxjs/operators";
import { IdPersistence } from "../../../constants/IdPersistence";
import { selectCoopInfo, selectCoopSearchSelectedCoop } from "../../../selectors/selectCoopInfo";
import { selectOwnPlayerId } from "../../../selectors/selectPlayerInfo";
import { CommandCode, PlayerPreferencesPlatformType, } from "../../../utils/network/generated/protoTypes";
import { actionServerPersistenceRemove } from "../../server-persistence/actionServerPersistence";
import { actionCoopClearSelectedCoop, actionCoopInfoJoinCoop, actionCoopInfoLeaveCoopSuccessfully, actionCoopMenuSetFirstTab, actionCoopMenuTabGoTo, TypeActionCoopInfo, } from "../actionCoop";
import { IdCoopCategory } from "../IdCoopCategory";
export var epicCoopLeave = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionCoopInfo.LeaveCoop), switchMap(function (action) {
        var state = state$.value;
        var playerId = selectOwnPlayerId(state);
        var coop = selectCoopInfo(state);
        // not member of coop
        if (!coop) {
            return EMPTY;
        }
        return deps
            .netSend({
            id: CommandCode.LeaveCoop,
            props: {
                coopId: coop.id,
                playerId: playerId,
            },
        })
            .pipe(switchMap(function (res) {
            var actions = [
                actionCoopInfoLeaveCoopSuccessfully(),
                // we set value to null to reset the persistenceValue
                // the next time we update coop info
                actionServerPersistenceRemove([
                    {
                        key: IdPersistence.CoopPreviousRanking,
                        platform: PlayerPreferencesPlatformType.PLAT_SHARED,
                    },
                ]),
            ];
            var selectedCoop = selectCoopSearchSelectedCoop(state$.value);
            if (selectedCoop) {
                // we default to 1 cause coop don't have level 0
                actions.push(actionCoopInfoJoinCoop({ coopId: selectedCoop.id }));
            }
            actions.push(actionCoopMenuSetFirstTab(IdCoopCategory.CoopFound), actionCoopMenuTabGoTo(IdCoopCategory.CoopSearch), actionCoopClearSelectedCoop());
            return from(actions);
        }), retry());
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/epic/epicCoopLeave.ts
// module id = 1812
// module chunks = 3